import { Accordion, Col, Form, Row } from "react-bootstrap";
import { CensusCategory } from "../../../types/Census/CensusCategory";
import { CensusColumn } from "../../../types/Census/CensusColumn";
import { CensusSelectedColumnType } from "../../../types/Census/CensusSelectedColumn";
import { CensusFormData } from "./Census";
import { CensusAccordionHeader } from "./CensusAccordionHeader";
import ThemedSelect from "../../../@ui/ThemedSelect";

interface ColumnSelectionProps {
  categories: CensusCategory[];
  isLoading: {
    categories: boolean;
  };
  values: CensusFormData;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void;
  handleSelectedColumnChange: (
    categoryId: number | null,
    values: CensusFormData,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined,
    ) => void,
  ) => void;
}

const ColumnSelection = ({
  categories,
  isLoading,
  values,
  setFieldValue,
  handleSelectedColumnChange,
}: ColumnSelectionProps) => {
  const disabledColumnOptionCheck = (
    columnId: number,
    values: CensusFormData,
    categoryId: number,
  ): boolean => {
    if (columnId === -1) {
      return (
        values.columns.find(
          (x) =>
            x.type === CensusSelectedColumnType.Category &&
            x.value == values.categoryId,
        ) !== undefined
      );
    } else {
      return (
        values.columns.find(
          (x) =>
            (x.type === CensusSelectedColumnType.Individual &&
              x.value == columnId) ||
            (x.type === CensusSelectedColumnType.Category &&
              x.value == categoryId),
        ) !== undefined
      );
    }
  };

  return (
    <>
      <Accordion.Item eventKey="0">
        <CensusAccordionHeader>Column Selection</CensusAccordionHeader>
        <Accordion.Body>
          <Row className="justify-content-center">
            <Col>
              <Form.Group>
                <Form.Label>Census Categories</Form.Label>
                <ThemedSelect
                  value={
                    values.categoryId === -1 ?
                      null
                    : {
                        value: values.categoryId.toString(),
                        label: categories.find(
                          (col) => col.categoryId === values.categoryId,
                        )?.categoryName,
                      }
                  }
                  options={(() => {
                    let categoryOptions = categories.map((category) => ({
                      value: category.categoryId.toString(),
                      label: category.categoryName,
                      isDisabled: !category.columns.some((col) => col.haveData),
                    }));

                    categoryOptions.unshift({
                      value: "-1",
                      label: "All Categories",
                      isDisabled: false,
                    });

                    return categoryOptions;
                  })()}
                  isLoading={isLoading.categories}
                  isDisabled={!values.releaseYear || isLoading.categories}
                  onChange={(opt: any) => {
                    if (opt !== null) {
                      setFieldValue("categoryId", parseInt(opt.value));
                      setFieldValue("columnId", -1);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="justify-content-center mt-3">
            <Col>
              <Form.Group>
                <Form.Label>Census Columns</Form.Label>

                <ThemedSelect
                  value={
                    values.columnId === -1 || values.columnId === undefined ?
                      null
                    : {
                        value: values.columnId.toString(),
                        label: categories
                          .find((cat) => cat.categoryId === values.categoryId)
                          ?.columns.find(
                            (col) => col.columnId === values.columnId,
                          )?.name,
                      }
                  }
                  options={
                    (
                      values.categoryId !== -1 &&
                      values.categoryId !== undefined
                    ) ?
                      (() => {
                        let options = categories
                          .find((cat) => cat.categoryId === values.categoryId)
                          ?.columns.map((column: CensusColumn) => ({
                            value: column.columnId.toString(),
                            label: column.name,
                            isDisabled:
                              !column.haveData ||
                              disabledColumnOptionCheck(
                                column.columnId,
                                values,
                                values.categoryId,
                              ),
                          }));

                        options !== undefined &&
                          options.unshift({
                            value: "-1",
                            label: "All Columns",
                            isDisabled: disabledColumnOptionCheck(
                              -1,
                              values,
                              values.categoryId,
                            ),
                          });

                        return options;
                      })()
                    : categories.map((category) => ({
                        label: category.categoryName,
                        options: [
                          {
                            value: "-1",
                            label: "Select a category first",
                            isDisabled: true,
                          },
                        ],
                      }))
                  }
                  isLoading={isLoading.categories}
                  isDisabled={
                    !values.categoryId ||
                    values.categoryId === -1 ||
                    !values.releaseYear ||
                    values.outputArea === undefined ||
                    isLoading.categories
                  }
                  onChange={(opt: any) => {
                    if (opt !== null) {
                      setFieldValue("columnId", parseInt(opt.value));
                      handleSelectedColumnChange(
                        parseInt(opt.value),
                        values,
                        setFieldValue,
                      );
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default ColumnSelection;
